<style>
#ChangePasswordUser .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 500px !important;
}
#ChangePasswordUser .v-input__slot,
#ChangePasswordUser .v-text-field__slot label {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="ChangePasswordUser"
    title="Zmiana hasła użytkownika"
    @saved="save"
    @closed="close"
    :buttons="['save']"
  >
    <div class="wrapper">
      <v-layout>
        <v-flex xs12>
          <div class="input__wrapper">
            <v-text-field
              v-model="password1"
              id="password1"
              type="password"
              :rules="[rules.required, rules.bigLetter, rules.len, rules.specialCase]"
              label="Nowe hasło"
            ></v-text-field>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="input__wrapper">
            <v-text-field
              v-model="password2"
              id="password2"
              type="password"
              oncopy="return false"
              :rules="[rules.required, rules.bigLetter, rules.len, rules.specialCase]"
              :error-messages="passwordMatchError()"
              label="Powtórz hasło"
            ></v-text-field>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    password1: undefined,
    password2: undefined,
    rules: {
      required: value => !!value || "Pole wymagane",
      bigLetter: value => /[A-Z]/.test(value) || "Wymagana jest wielka litera",
      len: value => value.length > 6 || "Hasło musi być dłuższe niż 6 znaków",
      specialCase: value =>
        /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value) ||
        "Wymagany jest znak specjalny"
    }
  }),
  computed: {
    userId() {
      return this.$store.getters.getCurrentUserId;
    }
  },
  watch: {
    password2(val) {
      if (val && (val.length > 0 && val == this.password1)) {
        this.passwordMatchError();
      }
    }
  },
  methods: {
    passwordMatchError() {
      return this.password1 == this.password2
        ? ""
        : "Podane hasła muszą być identyczne";
    },
    save() {
      if (!this.password1 || !this.password2) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Uzupełnij wszystkie wymagane pola"
        );
        return;
      }
      if (this.password1 != this.password2) {
        this.$root.$emit("showSnackbar", "red", "Hasła nie są identyczne!");
        return;
      }
      const self = this;
      let payload = {
        uid: this.userId,
        body: {
          password: this.password2
        }
      };
      this.$store.dispatch("modifyUser", payload).then(success => {
        if (success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Poprawnie zmieniono hasło użytkownika"
          );
          this.$modal.hide("ChangePasswordUser");
          self.close();
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd podczas zmiany hasła użytkownika"
          );
        }
      });
    },
    close() {
      this.password1 = undefined;
      this.password2 = undefined;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/ChangePasswordUser.vue